module.exports = __webpack_public_path__ + "img/betfinder.799a5046.png";